'use client';

import React, { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import { classNames } from '@/shared/lib/classnames/classnames';
import { UnderlineEffect } from '@/shared/ui/underline-effect';
import { getFooterItems } from '../../utils/getFooterItems';
import inputsIcons from '@/shared/assets/sprites/inputs.sprite.svg';
interface Props {
  cityAlias: string;
}
export const SectionLinks: React.FC<Props> = ({
  cityAlias
}) => {
  const t = useTranslations();
  const [openSections, setOpenSections] = useState<number[]>([]);
  const [isMobile, setIsMobile] = useState(false);
  const sectionsTitle = ['shared.footer.toPatient', 'shared.footer.information', 'shared.footer.about_us'];
  const footerItems = getFooterItems(cityAlias);
  const toggleSection = (index: number) => {
    setOpenSections(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };
  useEffect(() => {
    const checkMobile = () => {
      if (typeof window !== 'undefined') {
        setIsMobile(window.innerWidth < 768);
      }
    };
    checkMobile();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', checkMobile);
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', checkMobile);
      }
    };
  }, []);
  return <div className="grid grid-cols-1 lg:grid-cols-3" data-sentry-component="SectionLinks" data-sentry-source-file="SectionLinks.tsx">
      {sectionsTitle.map((title, index) => <section key={`column-title-${index}`}>
          <div className="peer">
            <button onClick={() => toggleSection(index)} className="mb-2 w-full cursor-pointer text-lg font-normal leading-6 md:cursor-default">
              <div className={classNames('flex items-center justify-between py-2 text-lg text-white md:justify-start', {
            'border-b border-white/20 lg:border-b-0': index !== sectionsTitle.length - 1
          })}>
                {t(title)}
                <svg aria-hidden="true" className={classNames('ml-2 size-5 rotate-180 transition-transform duration-200 md:hidden', {
              'rotate-0': openSections.includes(index)
            })}>
                  <use xlinkHref={`${inputsIcons}#chevron-up`}></use>
                </svg>
              </div>
            </button>

            <ul className={classNames('overflow-hidden transition-all duration-200 md:!block', {
          'max-h-0': !openSections.includes(index) && isMobile,
          'max-h-[500px]': openSections.includes(index) || !isMobile
        })}>
              {footerItems[index].map(item => <li key={`footer-item-${item.name}`} className="mb-2 text-sm">
                  <div className="peer/link-wrapper text-left">
                    <Link href={`${item.href}`} prefetch={false} className="relative overflow-hidden">
                      <UnderlineEffect className="text-base text-white" color="bg-white">
                        {t(item.name)}
                      </UnderlineEffect>
                    </Link>
                  </div>
                </li>)}
            </ul>
          </div>
        </section>)}
    </div>;
};